class GoogleMapController {
    constructor($scope, $element) {
        this.$scope = $scope;
        this.mapEl = $element.find('.googleMap-canvas')[0];
        this.map = new google.maps.Map(this.mapEl, this.mapOptions || {});

        this.removeTabs = this.removeTabs !== undefined ? this.removeTabs : false;

        setTimeout(() => this.addListeners());

        $scope.$watch(
            () => this.mapOptions,
            () => this.map.setOptions(this.mapOptions),
            true,
        );
    }

    addListeners() {
        if (this.onIdle) {
            this.map.addListener('idle', () => this.$scope.$apply(() => this.onIdle()));
        }

        if (this.onClick) {
            this.map.addListener('click', () => this.$scope.$apply(() => this.onClick()));
        }

        if (this.onZoomChanged) {
            this.map.addListener('zoom_changed', () => this.$scope.$apply(() => this.onZoomChanged()));
        }

        if (this.removeTabs) {
            this.map.addListener('tilesloaded', () => this.removeLinks());
        }
    }

    removeLinks() {
        setTimeout(() => {
            $(this.mapEl).find('a').prop('tabIndex', -1);
            $(this.mapEl).find('a').prop('aria-hidden', true);
        }, 3000);
    }

    triggerResize() {
        google.maps.event.trigger(this.map, 'resize');
    }

    getMap() {
        return this.map;
    }
}

const googleMapDirectiveDefinition = () => ({
    restrict: 'E',
    scope: {},
    bindToController: {
        map: '=?',
        mapOptions: '=',
        mapStyle: '=?',
        onIdle: '&?',
        onZoomChanged: '&?',
        onClick: '&?',
        removeTabs: '<?',
    },
    controller: ['$scope', '$element', GoogleMapController],
    controllerAs: 'googleMapCtrl',
    transclude: true,
    template: '<div ng-style="googleMapCtrl.mapStyle" class="googleMap-canvas"></div><ng-transclude></ng-transclude>',
});

module.exports = {
    GoogleMapController,
    googleMapDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-map.directive.js